export const IconInformationCircleLearnMore: {
  name: 'icon_information_circle_learn_more-222b50de50ce'
} = {
  name: 'icon_information_circle_learn_more-222b50de50ce'
}
